import React, { type ErrorInfo, type ReactNode } from "react";

const isMosaicError = (message: string | undefined): boolean => {
	const mosaicRegex = /mosaic/i;
	return message ? mosaicRegex.test(message) : false;
};

type ErrorBoundaryProps = {
	children: ReactNode;
	onError: () => void;
};

type ErrorBoundaryState = {
	hasError: boolean;
	error: Error | null;
};

class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Error caught by ErrorBoundary:", error, errorInfo);
	}

	render() {
		if (this.state.hasError && isMosaicError(this.state.error?.message)) {
			this.props.onError();
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
